import React, {Component} from 'react';
import styles from './LegalSection.scss';
import classNames from 'classnames/bind';
import {observable, action} from 'mobx';
import {observer} from 'mobx-react';
import {TabItem} from '../../atoms';
import legalContents from '../../../../assets/contents/legal';

const cx = classNames.bind(styles);

const DEFAULT_TAB = 'privacy';

@observer
class LegalSection extends Component {
  @observable activeTab = DEFAULT_TAB;

  @action clickTab = (clickedTab) => this.activeTab = clickedTab;

  handleClick = (clickedTab) => {
    this.clickTab(clickedTab);
  };

  render() {
    const {activeTab, handleClick} = this;

    return (
      <div className={cx('LegalSection')}>
        <h2 className={cx('LegalSection__title')}>{legalContents.legalTitle}</h2>
        <ul className={cx('LegalSection__tab-list')}>
          <TabItem
            tabName={'privacy'}
            displayName={legalContents.privacy.tabName}
            activeTab={activeTab}
            onClick={handleClick}
          />
          <TabItem
            tabName={'terms'}
            displayName={legalContents.terms.tabName}
            activeTab={activeTab}
            onClick={handleClick}
          />
          <TabItem
            tabName={'warranty'}
            displayName={legalContents.warranty.tabName}
            activeTab={activeTab}
            onClick={handleClick}
          />
        </ul>
        <div className={cx('LegalSection__tab-contents')}>
          <h5>{legalContents[activeTab].header}</h5>
          <p>{legalContents[activeTab].description}</p>
        </div>
      </div>
    );
  }
}

export default LegalSection;



// WEBPACK FOOTER //
// ./src/app/components/organisms/LegalSection/LegalSection.js